module.exports = __webpack_public_path__ + "img/location.48e8104f.svg";